import { makeStyles } from '@material-ui/core';

import {
  SIDEBAR_WIDTH,
  SIDEBAR_WIDTH_COLLAPSED,
} from './Sidebar';

export default makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    transition: 'padding-left .18s ease',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: SIDEBAR_WIDTH,
    },
  },
  wrapperCollapsed: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    transition: 'padding-left .18s ease',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: SIDEBAR_WIDTH_COLLAPSED,
    },
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
  },
}));
